import type { FunctionComponent } from 'react';
import React from 'react';
import { UserPanel } from './UserPanel';
import type { AppController } from '@/engine/app/App.controller';
import { TYPES } from '@/engine/ioc/types';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';
import { useSurgerySpecificUiConfigValue } from '@/engine/app/modules/ui';
import { NullComponent } from '@/engine/app/modules/ui/useUiConfigValue';
import { PresentationHeaderPanel } from './PresentationHeaderPanel';
import { HeaderCenterContent } from './HeaderCenterContent';

export const DefaultHeaderPanel: React.FC = observer(() => {
  const appController = useInjection<AppController>(TYPES.AppController);
  const caseState = appController.getCaseState();

  const userPanelChild = React.createElement(
    useSurgerySpecificUiConfigValue<FunctionComponent>('userPanelChild', NullComponent)
  );

  return (
    <PresentationHeaderPanel
      leftContent={<h2 style={{ fontWeight: 'normal', fontSize: '0.9em' }}>{caseState.surgeryTypeName}</h2>}
      centerContent={<HeaderCenterContent />}
      rightContent={<UserPanel caseCode={caseState.caseCode}>{userPanelChild}</UserPanel>}
    />
  );
});
